













































import { Component, Vue } from "vue-property-decorator";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoRestrictionOverview from "./Restrictions/DoKoRestrictionOverview.vue";
import DoKoRestrictionSolo from "./Restrictions/DoKoRestrictionSolo.vue";
import DoKoRestrictionWedding from "./Restrictions/DoKoRestrictionWedding.vue";
import DoKoRestrictionPoverty from "./Restrictions/DoKoRestrictionPoverty.vue";
import DoKoRestrictionSoloJ from "./Restrictions/DoKoRestrictionSoloJ.vue";
import DoKoRestrictionSoloQ from "./Restrictions/DoKoRestrictionSoloQ.vue";
import DoKoRestrictionSoloColor from "./Restrictions/DoKoRestrictionSoloColor.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { ItemRef, Restriction } from "@dokogd/shared";

@Component({
  components: {
    DoKoHtmlDialog,
    DoKoBtn,
    DoKoRestrictionSolo,
    DoKoRestrictionWedding,
    DoKoRestrictionPoverty,
    DoKoRestrictionSoloJ,
    DoKoRestrictionSoloQ,
    DoKoRestrictionSoloColor,
    DoKoRestrictionOverview,
  },
})
export default class DoKoDialogRestrictions extends Vue {
  closeable = false;
  contentComponent = "DoKoRestrictionOverview";

  @Getter(deskApi.getters.getLoadingState, { namespace: deskApi.namespace })
  loading!: boolean;

  @Getter(deskApi.getters.getHaveISendMyHealthCheck, {
    namespace: deskApi.namespace,
  })
  haveISendMyHealthCheck!: boolean;

  @Getter(deskApi.getters.getOpenHealthChecks, { namespace: deskApi.namespace })
  openHealthChecks!: number;

  @Getter(deskApi.getters.getUnCheckedPlayer, { namespace: deskApi.namespace })
  unCheckedPlayer!: Array<ItemRef>;

  @Action(deskApi.actions.announceRestriction, {
    namespace: deskApi.namespace,
  })
  announceRestriction!: (restriction: Restriction) => Promise<void>;

  selected(val?: string): void {
    this.contentComponent = val ?? "DoKoRestrictionOverview";
    this.closeable = !!val;
  }

  sendAnnounceRestriction(restriction: Restriction): void {
    console.log("sendAnnounceRestriction", restriction);
    this.announceRestriction(restriction);
  }
}
